import { all } from "redux-saga/effects";
import getCampaignDetail from "./getCampaignDetail";
import getListCampaign from "./getListCampaign";
import getListCampaignSplash from "./getListCampaignSplash";
import getLoyaltyDetail from "./getLoyaltyDetail";
import getLoyaltyPointDetail from "./getLoyaltyPointDetail";
import getMerchandisingDetail from "./getMerchandisingDetail";

export const specialOfferPageSaga = function* root() {
	yield all([
		getCampaignDetail(),
		getListCampaign(),
		getListCampaignSplash(),
		getLoyaltyDetail(),
		getLoyaltyPointDetail(),
		getMerchandisingDetail()
	]);
};
